import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

const TAG_KEY_RE = /^[a-zA-Z0-9_\-.]+$/;

const tagsValidator = Yup.string()
  .label("Tags")
  .test("valid-tags", "Each tag must be in key=value format with a valid key.", (value) => {
    if (!value) return true;
    const parts = value
      .split(/[,\n\r]+/)
      .map((p) => p.trim())
      .filter(Boolean);
    return parts.every((part) => {
      const eq = part.indexOf("=");
      if (eq <= 0 || eq === part.length - 1) return false;
      const key = part.slice(0, eq);
      const val = part.slice(eq + 1);
      return TAG_KEY_RE.test(key) && val.length > 0;
    });
  });

export const GrafanaGraphiteShape = {
  graphite_url: Yup.string().label("Graphite Endpoint URL").url().required(),
  metrics_instance_id: Yup.string().label("Metrics Instance ID").required(),
  metrics_api_token: Yup.string().label("Metrics API Token").required(),
  tags: tagsValidator,
};

export interface GrafanaGraphiteInput {
  graphite_url: string;
  metrics_instance_id: string;
  metrics_api_token: string;
  tags?: string;
}

export const GrafanaGraphiteDefaults = {tags: ""};

yupResolver<GrafanaGraphiteInput>(Yup.object().shape(GrafanaGraphiteShape));
